export interface Currency {
  code: string;
  pattern: string;
  symbol: string;
  primary?: boolean;
  base?: string;
  rate?: number;
}

export interface CurrencyConfig {
  activeCurrency: Currency;
  currencies?: Currency[];
}

export const DISPLAY_CURRENCY_COOKIE_NAME = 'displayCurrency';
